import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ServiceCard from '../Components/ServiceCard';
import ReactImage from '../img/atomic.png';
import PythonImage from '../img/python.png';
import DesignImage from '../img/adobe.png';

function ServicesSection() {
    return (
        <InnerLayout>
            <ServicesSectionStyled>
                <Title title={'Services'} span={'サービス'} />
                <div className="services">
                    <ServiceCard 
                        image={ReactImage} 
                        title={'Front-End'} 
                        paragraph={'Build responsive website app with reactJS, JavaScript and HTML/CSS with an attractive design.'}
                    />
                    <div className="mid-card">
                        <ServiceCard 
                            image={DesignImage} 
                            title={'Design'} 
                            paragraph={'Creating UI/UX and unique design with adobe. Fully responsive website with attractive animation effect.'}
                        />
                    </div>
                    <ServiceCard 
                        image={PythonImage} 
                        title={'Back-End'} 
                        paragraph={'Design structure back-end with python, databases (MySQL) and (MongoDB) also with Rest API and make full-stack webiste.'}
                    />
                </div>
            </ServicesSectionStyled>
        </InnerLayout>
    )
}

const ServicesSectionStyled = styled.section`
    .services{
        margin-top: 5rem;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 1.5rem;
        @media screen and (max-width:1000px){
            padding: 1rem 1.5rem;
            flex-direction: column;
        }
        @media screen and (max-width:950px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media screen and (max-width:650px){
            grid-template-columns: repeat(1, 1fr);
        }
       
    }
`;

export default ServicesSection;
